import { Input, Select, Space } from 'antd'
import { Typography } from 'modules/core/components'
import configuration from 'modules/configuration'
import { generateSelectOptions } from 'modules/core/utils'
import { CONCEPTS } from 'modules/core/constants'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import login from 'modules/login'

const SelectsOptions = ({
  setDataSelected,
  dataSelected,
  current,
  fetchAreasList,
  fetchCurrencyList,
  currencyList,
  areaList,
  fetchAllDimensions,
  fetchAllDimensionsValues,
  allDimensionsList,
  fetchBudgetTypeList,
  budgetTypeList,
  loggedUser: { pkid },
}) => {
  const { t } = useTranslation()
  const [societyOptions, setSocietyOptions] = useState([])

  useEffect(() => {
    if (currencyList?.data?.length > 0) {
      const colCurrency = currencyList.data.find((c) => c.code === 'COP')
      if (colCurrency) {
        setDataSelected((prevState) =>
          prevState?.currency ? prevState : { ...prevState, currency: colCurrency.id },
        )
      }
    }
  }, [currencyList, setDataSelected])

  useEffect(() => {
    if (budgetTypeList?.values?.length > 0) {
      const expensesConcept = budgetTypeList.values.find((c) => c.id === CONCEPTS.IDS.EXPENSES_ID)
      if (expensesConcept) {
        setDataSelected((prevState) =>
          prevState?.concept_id ? prevState : { ...prevState, concept_id: expensesConcept.id },
        )
      }
    }
  }, [budgetTypeList, setDataSelected])

  const societyDimension = allDimensionsList.find((dimension) => {
    const dimensionName = dimension?.name_destination?.toLowerCase()
    return dimensionName === 'sociedad' || dimensionName === 'society'
  })

  useEffect(() => {
    fetchCurrencyList()
  }, [fetchCurrencyList])

  useEffect(() => {
    fetchAreasList({ user_id: pkid })
  }, [fetchAreasList, pkid])

  useEffect(() => {
    fetchAllDimensions()
  }, [fetchAllDimensions])

  useEffect(() => {
    fetchBudgetTypeList()
  }, [fetchBudgetTypeList])

  useEffect(() => {
    if (societyDimension?.id) {
      fetchAllDimensionsValues({ id_dimension: societyDimension.id }).then((response) => {
        setSocietyOptions(
          response.payload.data
            .filter(
              (dimensionValue) =>
                !dimensionValue.name_destination?.toLowerCase().includes('valor sin asignar'),
            )
            .map((dimensionValue) => {
              return {
                ...dimensionValue,
                name: dimensionValue.name_destination,
                code: dimensionValue.code_destination,
              }
            }),
        )
      })
    }
  }, [fetchAllDimensionsValues, societyDimension])

  const CREATE_OPTIONS = [
    {
      id: 'EXPANSION',
      name: 'LABEL_EXPANSION',
    },
    {
      id: 'REDUCTION',
      name: 'LABEL_REDUCTION',
    },
    {
      id: 'RECLASSIFICATION',
      name: 'LABEL_RECLASSIFICATION',
    },
  ]

  const dataSelects = [
    {
      id: 'adjustment_type',
      name: 'FIELD_TYPE',
      options: CREATE_OPTIONS,
    },
    {
      id: 'currency',
      name: 'LABEL_CURRENCY',
      options: currencyList.data,
    },
    {
      id: 'concept_id',
      name: 'FIELD_CONCEPT',
      options: budgetTypeList?.values ?? [],
    },
    {
      id: 'area',
      name: 'LABEL_AREA',
      options: areaList,
    },
    {
      id: 'society',
      name: 'LABEL_COMPANY',
      options: societyOptions,
    },
  ]

  return (
    <Space direction="horizontal">
      {dataSelects.map((data) => (
        <Space key={data.id} direction="vertical">
          <Typography.Body level={2}>{t(data.name)}</Typography.Body>
          <Select
            placeholder={t('ACTION_SELECT')}
            disabled={
              data.id === 'currency' ||
              data.id === 'concept_id' ||
              (current > 0 && data.id === 'adjustment_type')
            }
            options={generateSelectOptions({
              options: data.options.map((el) => {
                return { ...el, name: t(el.name) }
              }),
            })}
            style={{ width: 240 }}
            value={dataSelected?.[data.id] ?? undefined}
            onChange={(val) =>
              setDataSelected((prevState) => {
                return { ...prevState, [data.id]: val }
              })
            }
          />
        </Space>
      ))}
      <Space direction="vertical">
        <Typography.Body level={2}>{t('FIELD_OBSERVATIONS')}</Typography.Body>
        <Input.TextArea
          placeholder={t('WRITE_SOMETHING_PLACEHOLDER')}
          rows={1}
          style={{ width: 290 }}
          onChange={(v) =>
            setDataSelected((prevState) => {
              return { ...prevState, description: v.target.value }
            })
          }
        />
      </Space>
    </Space>
  )
}

const mapStateToProps = (state) => ({
  currencyList: configuration.selectors.getCurrencyList(state),
  areaList: configuration.selectors.getAreaList(state),
  allDimensionsList: configuration.selectors.getAllDimensionsList(state),
  budgetTypeList: configuration.selectors.getBudgetTypeList(state),
  loggedUser: login.selectors.getWhoAmI(state),
})

const mapDispatchToProps = {
  fetchCurrencyList: configuration.actions.fetchCurrencyList,
  fetchAreasList: configuration.actions.fetchAreasList,
  fetchAllDimensions: configuration.actions.fetchAllDimensions,
  fetchAllDimensionsValues: configuration.actions.fetchAllDimensionsValues,
  fetchBudgetTypeList: configuration.actions.fetchBudgetTypeList,
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectsOptions)
